/* tslint:disable */

/**
 */
export class inline_response_200 {
    msg?: string;
    status?: number;
}
